import IMask from 'imask';

const masks = {
    tel: IMask.createMask({
        mask: "+0 000 000 00 00",
    }),
};

export const maskedTel = (v) => masks['tel'].resolve(v);

export const countdownTimer = (sec) => {
    let res = [];

    let h = Math.floor(sec / 3600);
    if (h) {
        res.push(`${h} ч.`);
        sec -= h * 3600;
    }

    let m = Math.floor(sec / 60);
    if (m || h) {
        res.push(`${m} мин.`);
        sec -= m * 60;
    }

    res.push(`${sec} сек.`);

    return res.join(' ');
};

export const isEmpty = (val) => {
    return (
        val === undefined ||
        val === null ||
        val === "" ||
        (typeof val === "number" && isNaN(val)) ||
        (val instanceof Array && val.length === 0) ||
        (val instanceof Object && Object.keys(val).length === 0)
    );
};
